import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationValidationService } from './modules/shared/services/authentication-validation.service';
import { ExportUserDetailsComponent } from './pages/export-user-details/export-user-details.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SupportComponent } from './pages/support/support.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.components';
import { TrackMyLocationComponent } from './pages/track-my-location/track-my-location.component';
import { AccessDeniedPageComponent } from './pages/access-denied/access-denied-page.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'signin'
  },
  {
    path: 'signin',
    pathMatch: 'full',
    component: SignInComponent
  },
  {
    path: 'export-details/:token',
    pathMatch: 'full',
    component: ExportUserDetailsComponent
  },
  {
    path: 'trackmylocation',
    pathMatch: 'full',
    component: TrackMyLocationComponent
  },
  {
    path: 'reset-password/:token',
    pathMatch: 'full',
    component: ResetPasswordComponent
  },
  {
    path: 'privacy-policy',
    pathMatch: 'full',
    component: PrivacyPolicyComponent
  },
  {
    path: 'support',
    pathMatch: 'full',
    component: SupportComponent
  },
  {
    path: 'terms-conditions',
    pathMatch: 'full',
    component: TermsConditionsComponent
  },
  {
    path: 'access-denied',
    canActivate: [AuthenticationValidationService],
    component: AccessDeniedPageComponent
  },
  {
    path: 'admin-dashboard',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'bookings',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/bookings/bookings.module').then(m => m.BookingsModule)
  },
  {
    path: 'emergency',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/emergency/emergency.module').then(m => m.EmergencyModule)
  },
  {
    path: 'passengers',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/passengers/passengers.module').then(m => m.PassengersModule)
  },
  {
    path: 'vehicles',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/vehicles/vehicles.module').then(m => m.VehiclesModule)
  },
  {
    path: 'drivers',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/drivers/drivers.module').then(m => m.DriversModule)
  },
  {
    path: 'marketing',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/marketing/marketing.module').then(m => m.MarketingModule)
  },
  {
    path: 'user-management',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/user-management/user-management.module').then(m => m.UserManagementModule)
  },
  {
    path: 'events',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/event/event.module').then(m => m.EventModule)
  },
  {
    path: 'incidents-complaints',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/incidents-complaints/incidents-complaints.module').then(m => m.IncidentsComplaintsModule)
  },
  {
    path: 'reports',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'queue-management/queue-driver-list',
    redirectTo: 'queue-management',
    pathMatch: 'full'
  },
  {
    path: 'queue-management',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/queue-management/queue-management.module').then(m => m.QueueManagementModule)
  },
  {
    path: 'shift-management',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/shift-management/shift-management.module').then(m => m.ShiftManagementModule)
  },
  {
    path: 'manage-locations',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/manage-locations/manage-locations.module').then(m => m.ManageLocationsModule)
  },
  {
    path: 'manage-shuttles',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/manage-shuttles/manage-shuttles.module').then(m => m.ManageShuttlesModule)
  },
  {
    path: 'manage-teams',
    canActivate: [AuthenticationValidationService],
    loadChildren: () => import('./modules/driver-time-management/driver-time-management.module').then(m => m.DriverTimeManagementModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'disabled' })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
